import React, { useState } from 'react';

const CatalogOptionsField = ({ values = [], suggestions = [], listId, onChange }) => {
  const [draft, setDraft] = useState('');

  const addOption = () => {
    const option = draft.trim();

    if (!option) {
      return;
    }

    const exists = values.some((value) => value.toLowerCase() === option.toLowerCase());
    if (!exists) {
      onChange([...values, option]);
    }
    setDraft('');
  };

  return (
    <div className="create-product__field create-product__field--wide">
      <span>Catalog filter options</span>
      <div className="create-product__catalog-option-entry">
        <input
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              addOption();
            }
          }}
          list={listId}
          placeholder="Example: Quartz, Leather"
          autoComplete="off"
        />
        <button type="button" onClick={addOption}>Add option</button>
      </div>
      <datalist id={listId}>
        {suggestions.map((option) => <option key={option} value={option} />)}
      </datalist>
      <small>Add every material or catalog option that should match this product in filters.</small>
      <div className="create-product__catalog-options">
        {values.map((option) => (
          <button
            type="button"
            key={option}
            onClick={() => onChange(values.filter((value) => value !== option))}
            aria-label={`Remove ${option}`}
          >
            <span>{option}</span>
            <strong aria-hidden="true">×</strong>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CatalogOptionsField;
